import React, { useState, useEffect } from "react";
import useRestaurantData from "../Hooks/useRestaurantData";
import { useSelector } from "react-redux";
import { APP_IMG_CDN_URL } from "../helpers/Constant";
import Slider from "./Slider";
import RestaurantCard from "./RestaurantCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faXmark } from "@fortawesome/free-solid-svg-icons";
import orderBy from "lodash/orderBy";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";
import Footer from "./Footer";
import Unserviceable from "./Unserviceable";
import HomeShimmer from "./HomeShimmer";
import BetterFoodSection from "./BetterFoodSection";
import AppDownloadHero from "./AppDownloadHero";
import DownloadAppSection from "./DownloadAppSection";
import FoodDeliveryCards from "./FoodDeliveryCards";

const Home = () => {
  const [
    WOYM,
    topResList,
    sort,
    resList,
    filteredResList,
    setfilteredResList,
    appInstallLinks,
    footerCities,
    bestPlaces,
    bestCuiNearMe,
    expResNearMe,
    notServicable,
    popularRestaurants,
    fetchCuisines,
    fetchCuisineDetails,
    cuisinePagination,
    cuisineLoading,
    fetchPopularRestaurants,
    loadMorePopularRestaurants,
    loadPreviousPopularRestaurants,
    goToPopularRestaurantsPage,
    popularRestaurantsPagination,
    popularRestaurantsLoading,
    fetchRestaurantDetails,
    restaurantDetails,
    restaurantLoading,
    restaurantError
  ] = useRestaurantData();

  const locDetails = useSelector((store) => store.location.locationDetails);
  const locationSearchVisibility = useSelector(
    (store) => store.locSearch.visible
  );

  const [city, setCity] = useState(locDetails[0]?.district || "your city");
  const [sortActive, setSortActive] = useState(undefined);
  const [bestPlacesOpen, setBestPlacesOpen] = useState(false);
  const [bestCuiOpen, setBestCuiOpen] = useState(false);
  const [selectedCuisine, setSelectedCuisine] = useState(null);
  const [cuisineRestaurants, setCuisineRestaurants] = useState([]);
  const [showCuisineRestaurants, setShowCuisineRestaurants] = useState(false);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [showRestaurantModal, setShowRestaurantModal] = useState(false);

  useEffect(() => {
    if (locDetails && locDetails[0]) {
      setCity(locDetails[0].district);
      setSortActive(undefined);
    }
  }, [locDetails]);

  const handleSortClick = (text) => {
    if (text === sortActive && sortActive !== undefined) {
      setSortActive(undefined);
      setfilteredResList(resList);
    } else {
      setSortActive(text);
      if (text === "Relevance (Default)") {
        setfilteredResList(filteredResList);
      } else if (text === "DeliveryTime") {
        const sortedList = orderBy(
          filteredResList || [],
          ["info.sla.deliveryTime"],
          ["asc"]
        );
        setfilteredResList(sortedList);
      } else if (text === "Rating") {
        const sortedList = orderBy(
          filteredResList || [],
          ["info.avgRating"],
          ["desc"]
        );
        setfilteredResList(sortedList);
      } else if (text === "Cost:LowtoHigh") {
        const sortedList = orderBy(
          filteredResList || [],
          [(res) => parseInt(res.info.costForTwo?.split(" ")[0]?.slice(1) || 0)],
          ["asc"]
        );
        setfilteredResList(sortedList);
      } else if (text === "Cost:HightoLow") {
        const sortedList = orderBy(
          filteredResList || [],
          [(res) => parseInt(res.info.costForTwo?.split(" ")[0]?.slice(1) || 0)],
          ["desc"]
        );
        setfilteredResList(sortedList);
      }
    }
  };

  const handleMorePlaces = () => {
    setBestPlacesOpen(true);
  };

  const handleLessPlaces = () => {
    setBestPlacesOpen(false);
  };

  const handleMoreCui = () => {
    setBestCuiOpen(true);
  };

  const handleLessCui = () => {
    setBestCuiOpen(false);
  };

  const handleCuisineClick = async (cuisine) => {
    try {
      const details = await fetchCuisineDetails(cuisine.id);
      if (details) {
        setSelectedCuisine(details.cuisine);
        setCuisineRestaurants(details.restaurants);
        setShowCuisineRestaurants(true);
        console.log("Cuisine details:", details);
      }
    } catch (error) {
      console.error("Error fetching cuisine details:", error);
    }
  };

  const handleRestaurantClick = async (restaurantId) => {
    try {
      const details = await fetchRestaurantDetails(restaurantId);
      if (details) {
        setSelectedRestaurant(details);
        setShowRestaurantModal(true);
        console.log("Restaurant details:", details);
      }
    } catch (error) {
      console.error("Error fetching restaurant details:", error);
    }
  };

  const closeCuisineRestaurants = () => {
    setShowCuisineRestaurants(false);
    setSelectedCuisine(null);
    setCuisineRestaurants([]);
  };

  const closeRestaurantModal = () => {
    setShowRestaurantModal(false);
    setSelectedRestaurant(null);
  };

  const getPageNumbers = () => {
    if (!popularRestaurantsPagination) return [];
    const totalPages = popularRestaurantsPagination.last_page;
    const currentPage = popularRestaurantsPagination.current_page;
    const pageNumbers = [];
    
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) pageNumbers.push(i);
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) pageNumbers.push(i);
      } else {
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pageNumbers.push(i);
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };

  return resList?.length === 0 && !WOYM?.length ? (
    <HomeShimmer />
  ) : (
    <>
      {notServicable !== undefined ? (
        <Unserviceable />
      ) : (
        <div className="body xl:max-w-[80%] mx-auto min-h-screen px-4 sm:px-6 md:px-0">
          <div className="relative left-1/2 right-1/2 w-[99vw] -translate-x-1/2">
            <AppDownloadHero />
          </div>

          <FoodDeliveryCards/>

          {/* What's on your mind - Cuisine Section from Jagods API */}
          {WOYM && WOYM.length > 0 && (
            <>
              <div className="flex justify-between items-center mx-0 md:mx-12 px-0 md:px-4 my-4">
                <h1 className="font-bold text-xl md:text-[1.7rem] leading-tight md:leading-3 tracking-tight">
                  What's on your mind?
                </h1>
                <Slider className="foodCategory" amount={350} />
              </div>
              <div className="foodCategory container-snap mx-0 md:mx-12 flex p-4 overflow-x-auto scrollbar-hide gap-4 mb-8">
                {WOYM.map((item) => (
                  <div
                    className="cursor-pointer flex-shrink-0 text-center group transition-transform duration-300 hover:scale-105"
                    key={item.id}
                    onClick={() => handleCuisineClick(item)}
                  >
                    <div className="relative">
                      <img
                        className="bg-transparent h-[140px] w-[120px] md:h-[180px] md:w-[180px] object-contain"
                        src={item.image}
                        alt={item.name}
                        loading="lazy"
                        onError={(e) => {
                          console.error("Image failed to load:", item.image);
                          e.target.src = "https://via.placeholder.com/144x180?text=No+Image";
                        }}
                      />
                    </div>
                    <p className="mt-2 text-xs md:text-sm font-medium text-gray-700 group-hover:text-primary transition-colors duration-200">
                      {item.name}
                    </p>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Cuisine Restaurants Modal/View */}
          {showCuisineRestaurants && selectedCuisine && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
              <div className="bg-white rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white z-10 p-4 border-b flex justify-between items-center">
                  <div>
                    <h2 className="text-2xl font-bold">{selectedCuisine.name}</h2>
                    <p className="text-gray-500 text-sm mt-1">
                      {cuisineRestaurants.length} restaurants available
                    </p>
                  </div>
                  <button
                    onClick={closeCuisineRestaurants}
                    className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                  >
                    <FontAwesomeIcon icon={faXmark} size="lg" />
                  </button>
                </div>
                <div className="p-6">
                  {cuisineRestaurants.length > 0 ? (
                    <div className="grid place-items-center gap-4 md:gap-6 lg:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                      {cuisineRestaurants.map((restaurant) => (
                        <div 
                          key={restaurant.id} 
                          onClick={() => handleRestaurantClick(restaurant.id)}
                          className="cursor-pointer"
                        >
                          <RestaurantCard
                            id={restaurant.id}
                            name={restaurant.name}
                            image={restaurant.image}
                            avgRating={restaurant.avgRating}
                            avgRatingUser={restaurant.avgRatingUser}
                            estimated_delivery_time={restaurant.estimated_delivery_time}
                            is_open={restaurant.is_open}
                            restroType={restaurant.restroType}
                            description={restaurant.description}
                            address={restaurant.address}
                            coverImg={restaurant.coverImg}
                            locationSearchVisibility={locationSearchVisibility}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-12">
                      <p className="text-gray-500">No restaurants found for this cuisine.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Restaurant Details Modal */}
          {showRestaurantModal && selectedRestaurant && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
              <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white z-10 p-4 border-b flex justify-between items-center">
                  <div>
                    <h2 className="text-2xl font-bold">{selectedRestaurant.restaurant.name}</h2>
                    <p className="text-gray-500 text-sm mt-1">
                      {selectedRestaurant.restaurant.cuisines?.map(c => c.name).join(' • ')}
                    </p>
                  </div>
                  <button
                    onClick={closeRestaurantModal}
                    className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                  >
                    <FontAwesomeIcon icon={faXmark} size="lg" />
                  </button>
                </div>
                <div className="p-6">
                  {/* Restaurant Image */}
                  <div className="relative w-full h-64 rounded-xl overflow-hidden mb-6">
                    <img
                      src={selectedRestaurant.restaurant.image}
                      alt={selectedRestaurant.restaurant.name}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-4 left-4 bg-black bg-opacity-70 text-white px-4 py-2 rounded-lg">
                      <span className="text-2xl font-bold">⭐ {selectedRestaurant.avgRating || 'New'}</span>
                    </div>
                  </div>

                  {/* Restaurant Info */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <h3 className="font-semibold text-gray-700 mb-2">About</h3>
                      <p className="text-gray-600" 
                        dangerouslySetInnerHTML={{ __html: selectedRestaurant.restaurant.description }}
                      />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-700 mb-2">Details</h3>
                      <div className="space-y-2 text-sm">
                        <p><span className="font-medium">Address:</span> {selectedRestaurant.restaurant.address}</p>
                        <p><span className="font-medium">Opening Time:</span> {selectedRestaurant.restaurant.opening_time}</p>
                        <p><span className="font-medium">Closing Time:</span> {selectedRestaurant.restaurant.closing_time}</p>
                        <p><span className="font-medium">Delivery Charge:</span> ₹{selectedRestaurant.restaurant.delivery_charge}</p>
                        <p><span className="font-medium">Status:</span> 
                          <span className={`ml-2 px-2 py-1 rounded text-xs ${
                            selectedRestaurant.restaurant.current_status === 'current_status.5' 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-red-100 text-red-800'
                          }`}>
                            {selectedRestaurant.restaurant.current_status === 'current_status.5' ? 'Open' : 'Closed'}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Categories */}
                  {selectedRestaurant.categories && selectedRestaurant.categories.length > 0 && (
                    <div className="mb-6">
                      <h3 className="font-semibold text-gray-700 mb-3">Categories</h3>
                      <div className="flex flex-wrap gap-2">
                        {selectedRestaurant.categories.map((category) => (
                          <span 
                            key={category.id}
                            className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700"
                          >
                            {category.name}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Reviews */}
                  {selectedRestaurant.reviews && selectedRestaurant.reviews.length > 0 && (
                    <div>
                      <h3 className="font-semibold text-gray-700 mb-3">
                        Reviews ({selectedRestaurant.reviews.length})
                      </h3>
                      <div className="space-y-4 max-h-60 overflow-y-auto">
                        {selectedRestaurant.reviews.map((review) => (
                          <div key={review.id} className="border-b pb-4">
                            <div className="flex items-center gap-3 mb-2">
                              <img
                                src={review.userImage || 'https://via.placeholder.com/40'}
                                alt={review.user}
                                className="w-10 h-10 rounded-full object-cover"
                              />
                              <div>
                                <p className="font-medium">{review.user}</p>
                                <div className="flex items-center gap-2">
                                  <span className="text-yellow-500">⭐ {review.rating}</span>
                                  <span className="text-gray-400 text-sm">{review.created_at}</span>
                                </div>
                              </div>
                            </div>
                            <p className="text-gray-600 ml-12">{review.review}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="relative left-1/2 right-1/2 w-[99vw] -translate-x-1/2">
            <BetterFoodSection />
          </div>

          {/* Popular Restaurants from Jagods API */}
          {popularRestaurants.length > 0 && (
            <>
              <div className="mx-0 md:mx-8 my-6 md:my-8">
                <h1 className="font-bold text-xl md:text-[1.7rem] leading-tight md:leading-3 tracking-tight mb-6">
                  Popular Restaurants in {city}
                </h1>
              </div>
              <div className="grid place-items-center gap-4 md:gap-6 lg:gap-8 mx-auto px-4 md:px-8 my-6 md:my-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {popularRestaurants.map((restaurant) => (
                  <div
                    key={restaurant.id}
                    onClick={() => handleRestaurantClick(restaurant.id)}
                    className="cursor-pointer"
                  >
                    <RestaurantCard
                      id={restaurant.id}
                      name={restaurant.name}
                      image={restaurant.image}
                      avgRating={restaurant.avgRating}
                      avgRatingUser={restaurant.avgRatingUser}
                      estimated_delivery_time={restaurant.estimated_delivery_time}
                      is_open={restaurant.is_open}
                      restroType={restaurant.restroType}
                      description={restaurant.description}
                      address={restaurant.address}
                      coverImg={restaurant.coverImg}
                      locationSearchVisibility={locationSearchVisibility}
                    />
                  </div>
                ))}
              </div>

              {/* Pagination Controls */}
              {popularRestaurantsPagination && (
                <div className="flex flex-col items-center gap-4 my-8 px-4">
                  <div className="text-sm text-gray-600">
                    Showing {popularRestaurantsPagination.from} to {popularRestaurantsPagination.to} of {popularRestaurantsPagination.total} restaurants
                  </div>

                  <div className="flex flex-wrap items-center justify-center gap-2">
                    <button
                      onClick={loadPreviousPopularRestaurants}
                      disabled={!popularRestaurantsPagination.prev_page_url || popularRestaurantsLoading}
                      className={`px-4 py-2 rounded-lg border transition-colors duration-200 ${
                        popularRestaurantsPagination.prev_page_url && !popularRestaurantsLoading
                          ? "bg-white hover:bg-gray-50 text-gray-700 border-gray-300"
                          : "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
                      }`}
                    >
                      <span className="flex items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        Previous
                      </span>
                    </button>

                    {getPageNumbers().map((page, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          if (page !== '...') {
                            goToPopularRestaurantsPage(page);
                          }
                        }}
                        disabled={page === '...' || page === popularRestaurantsPagination.current_page || popularRestaurantsLoading}
                        className={`px-4 py-2 rounded-lg border transition-colors duration-200 min-w-[40px] ${
                          page === popularRestaurantsPagination.current_page
                            ? "bg-primary text-white border-primary"
                            : page === '...'
                            ? "bg-white text-gray-400 border-gray-200 cursor-default"
                            : "bg-white hover:bg-gray-50 text-gray-700 border-gray-300"
                        }`}
                      >
                        {page}
                      </button>
                    ))}

                    <button
                      onClick={loadMorePopularRestaurants}
                      disabled={!popularRestaurantsPagination.next_page_url || popularRestaurantsLoading}
                      className={`px-4 py-2 rounded-lg border transition-colors duration-200 ${
                        popularRestaurantsPagination.next_page_url && !popularRestaurantsLoading
                          ? "bg-white hover:bg-gray-50 text-gray-700 border-gray-300"
                          : "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
                      }`}
                    >
                      <span className="flex items-center gap-1">
                        Next
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </span>
                    </button>
                  </div>

                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <span>Show:</span>
                    <select
                      onChange={(e) => {
                        const perPage = parseInt(e.target.value);
                        fetchPopularRestaurants(1, perPage);
                      }}
                      defaultValue={popularRestaurantsPagination.per_page}
                      className="px-2 py-1 border border-primary rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                    <span>per page</span>
                  </div>
                </div>
              )}
            </>
          )}

          {/* Loading state for popular restaurants */}
          {popularRestaurantsLoading && (
            <div className="mx-0 md:mx-12 px-4">
              <div className="grid place-items-center gap-4 md:gap-6 lg:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                  <div key={i} className="w-full bg-white rounded-xl overflow-hidden shadow-md">
                    <div className="h-48 bg-gray-200 animate-pulse"></div>
                    <div className="p-4">
                      <div className="h-6 bg-gray-200 rounded animate-pulse mb-2"></div>
                      <div className="h-4 bg-gray-200 rounded animate-pulse mb-2"></div>
                      <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Best Places to Eat Across Cities */}
          {bestPlaces && bestPlaces.length > 0 && (
            <>
              <hr className="my-6 md:my-8" />
              <div className="">
                <h1 className="font-bold text-xl md:text-[1.7rem] leading-tight md:leading-3 tracking-tight mb-6">
                  Best Places to Eat Across Cities
                </h1>
              </div>
          <div className="flex flex-wrap gap-2 md:gap-x-2 justify-start md:justify-between my-6 md:my-8 px-4 md:px-0">
  {bestPlaces.slice(0, 11).map((x) => (
    <div
      key={x.text}
      className="
        group
        w-[48%]
        sm:w-[32%]
        md:w-[23%]
        lg:w-[18%]
        flex-grow
        p-3
        md:p-4
        mb-3
        md:mb-4
        cursor-pointer
        border
        border-solid
        border-primary/80
        rounded-xl
        transition-all
        duration-200
        hover:bg-primary/80
        hover:border-primary
      "
    >
      <h2
        className="
          truncate
          text-center
          text-sm
          md:text-base
          text-[#050e1bbf]
          group-hover:text-white
          tracking-tight
          font-medium
          transition-colors
          duration-200
        "
      >
        {x.text}
      </h2>
    </div>
  ))}

  {!bestPlacesOpen && bestPlaces.length > 11 && (
    <div
      onClick={handleMorePlaces}
      className="
        w-[48%]
        sm:w-[32%]
        md:w-[23%]
        lg:w-[18%]
        flex
        items-center
        justify-center
        flex-grow
        p-3
        md:p-4
        mx-0
        md:mx-2
        mb-3
        md:mb-4
        cursor-pointer
        border
        border-solid
        border-primary/50
        rounded-xl
        transition-all
        duration-200
        hover:bg-primary
        hover:text-white
        hover:border-primary
      "
    >
      <RiArrowDownSLine className="w-5 h-5 md:w-6 md:h-6 mr-1 md:mr-2" />

      <h2 className="truncate text-center text-sm md:text-base tracking-tight font-medium">
        Show more
      </h2>
    </div>
  )}

  {bestPlacesOpen && (
    <>
      {bestPlaces.slice(11).map((x) => (
        <div
          key={x.text}
          className="
            group
            w-[48%]
            sm:w-[32%]
            md:w-[23%]
            lg:w-[18%]
            flex-grow
            p-3
            md:p-4
            mb-3
            md:mb-4
            cursor-pointer
            border
            border-solid
            border-[#02060c1f]
            rounded-xl
            transition-all
            duration-200
            hover:bg-primary/80
            hover:border-primary
          "
        >
          <h2
            className="
              truncate
              text-center
              text-sm
              md:text-base
              text-[#050e1bbf]
              group-hover:text-white
              tracking-tight
              font-medium
              transition-colors
              duration-200
            "
          >
            {x.text}
          </h2>
        </div>
      ))}

      <div
        onClick={handleLessPlaces}
        className="
          w-[48%]
          sm:w-[32%]
          md:w-[23%]
          lg:w-[18%]
          flex
          items-center
          justify-center
          flex-grow
          p-3
          md:p-4
          mx-0
          md:mx-2
          mb-3
          md:mb-4
          cursor-pointer
          border
          border-solid
          border-primary/50
          rounded-xl
          transition-all
          duration-200
          hover:bg-primary
          hover:text-white
          hover:border-primary
        "
      >
        <RiArrowUpSLine className="w-5 h-5 md:w-6 md:h-6 mr-1 md:mr-2" />

        <h2 className="truncate text-center text-sm md:text-base tracking-tight font-medium">
          Show less
        </h2>
      </div>
    </>
  )}
</div>
            </>
          )}

          {/* Best Cuisines Near Me */}
        {bestCuiNearMe && bestCuiNearMe.length > 0 && (
  <>
    <hr className="my-6 md:my-8" />

    <div>
      <h1 className="font-bold text-xl md:text-[1.7rem] leading-tight md:leading-3 tracking-tight mb-6">
        Best Cuisines Near Me
      </h1>
    </div>

    <div className="flex flex-wrap gap-2 md:gap-x-2 justify-start md:justify-between my-6 md:my-8 px-4 md:px-0">

      {/* First 11 Cuisines */}
      {bestCuiNearMe.slice(0, 11).map((x) => (
        <div
          key={x.text}
          className="
            group
            w-[48%]
            sm:w-[32%]
            md:w-[23%]
            lg:w-[18%]
            flex-grow
            p-3
            md:p-4
            mb-3
            md:mb-4
            cursor-pointer
            border
            border-solid
            border-primary/80
            rounded-xl
            transition-all
            duration-200
            hover:bg-primary/80
            hover:border-primary
          "
        >
          <h2
            className="
              truncate
              text-center
              text-sm
              md:text-base
              text-[#050e1bbf]
              group-hover:text-white
              tracking-tight
              font-medium
              transition-colors
              duration-200
            "
          >
            {x.text}
          </h2>
        </div>
      ))}

      {/* Show More */}
      {!bestCuiOpen && bestCuiNearMe.length > 11 && (
        <div
          onClick={handleMoreCui}
          className="
            w-[48%]
            sm:w-[32%]
            md:w-[23%]
            lg:w-[18%]
            flex
            items-center
            justify-center
            flex-grow
            p-3
            md:p-4
            mx-0
            md:mx-2
            mb-3
            md:mb-4
            cursor-pointer
            border
            border-solid
            border-primary/50
            rounded-xl
            transition-all
            duration-200
            hover:bg-primary
            hover:text-white
            hover:border-primary
          "
        >
          <RiArrowDownSLine className="w-5 h-5 md:w-6 md:h-6 mr-1 md:mr-2" />

          <h2 className="truncate text-center text-sm md:text-base tracking-tight font-medium">
            Show more
          </h2>
        </div>
      )}

      {/* Remaining Cuisines */}
      {bestCuiOpen && (
        <>
          {bestCuiNearMe.slice(11).map((x) => (
            <div
              key={x.text}
              className="
                group
                w-[48%]
                sm:w-[32%]
                md:w-[23%]
                lg:w-[18%]
                flex-grow
                p-3
                md:p-4
                mb-3
                md:mb-4
                cursor-pointer
                border
                border-solid
                border-primary/80
                rounded-xl
                transition-all
                duration-200
                hover:bg-primary/80
                hover:border-primary
              "
            >
              <h2
                className="
                  truncate
                  text-center
                  text-sm
                  md:text-base
                  text-[#050e1bbf]
                  group-hover:text-white
                  tracking-tight
                  font-medium
                  transition-colors
                  duration-200
                "
              >
                {x.text}
              </h2>
            </div>
          ))}

          {/* Show Less */}
          <div
            onClick={handleLessCui}
            className="
              w-[48%]
              sm:w-[32%]
              md:w-[23%]
              lg:w-[18%]
              flex
              items-center
              justify-center
              flex-grow
              p-3
              md:p-4
              mx-0
              md:mx-2
              mb-3
              md:mb-4
              cursor-pointer
              border
              border-solid
              border-primary/50
              rounded-xl
              transition-all
              duration-200
              hover:bg-primary
              hover:text-white
              hover:border-primary
            "
          >
            <RiArrowUpSLine className="w-5 h-5 md:w-6 md:h-6 mr-1 md:mr-2" />

            <h2 className="truncate text-center text-sm md:text-base tracking-tight font-medium">
              Show less
            </h2>
          </div>
        </>
      )}
    </div>
  </>
)}

          {/* Explore Every Restaurants Near Me */}
        {expResNearMe && expResNearMe.length > 0 && (
  <>
    <hr className="my-6 md:my-8" />

    <div>
      <h1 className="font-bold text-xl md:text-[1.7rem] leading-tight md:leading-3 tracking-tight mb-6">
        Explore Every Restaurants Near Me
      </h1>
    </div>

    <div className="flex flex-wrap gap-3 md:gap-4 justify-start px-4 md:px-0">
      {expResNearMe.map((x) => (
        <div
          key={x.text}
          className="
            group
            w-[47%]
            sm:w-[31%]
            md:w-[23%]
            lg:w-[18%]
            p-3
            md:p-4
            cursor-pointer
            border
            border-solid
            border-primary/80
            rounded-xl
            transition-all
            duration-200
            hover:bg-primary/80
            hover:border-primary
          "
        >
          <h2
            className="
              truncate
              text-center
              text-sm
              md:text-base
              text-[#050e1bbf]
              group-hover:text-white
              tracking-tight
              font-medium
              transition-colors
              duration-200
            "
          >
            {x.text}
          </h2>
        </div>
      ))}
    </div>
  </>
)}
          <div className="relative left-1/2 right-1/2 w-[99vw] -translate-x-1/2">
            <DownloadAppSection />
          </div>
        </div>
      )}

      {/* Footer */}
      <div>
        <Footer footerCities={footerCities} />
      </div>
    </>
  );
};

export default Home;